<template>
  <v-container class="white-wrapper" fluid> 

    <div  style="max-width:25rem;margin:0 auto;height:100%;display:flex;flex-direction:column;justify-content:space-between;padding: 0 1rem; " >    

      <v-card>           
          <v-tabs
            v-model="tab1"
            color="deep-purple-accent-4"
            align-tabs="center"
          > 
            <v-tab  @click="tab1Act(0)" style="width:33%;">KYC</v-tab>
            <v-tab  @click="tab1Act(1)" style="width:33%;">Card</v-tab>
            <v-tab  @click="tab1Act(2)" style="width:33%;">Deposit</v-tab>

          </v-tabs>          
      </v-card>

      <div v-show="tab1==0"> 
        <!-- KYC 인증  -->
        
        <div>

        </div>

        <v-btn
            class="font-weight-bold mb-4"
            color="primary"
            @click="confirmDialog = true"
            x-large
            block          
          >
            Request KYC
        </v-btn>

      </div>      
      <div v-show="tab1==1"> 
        <!-- 카드정보  -->
        10 
      </div>      
      <div v-show="tab1==2"> 
        <!-- 자산정보 --> 
        20
      </div>      

      
    </div>

    <v-bottom-sheet v-model="confirmDialog" scrollable>
      <v-card class="rounded-lg" style="min-height: 50vh;">
        <!-- kyc  -->
        <v-card-title> KYC User Information </v-card-title>
        <v-card-text class="type-wrapper" >
          <div class="sheet-title1">* Infomation</div>          
          <div class="sheet-row">
            <v-text-field
              class="swap-input-wrapper"
              label="Last name"
              placeholder="last name"
              v-model="KYC.info.last_name" 
            >
            </v-text-field>            
          </div>

          <div class="sheet-row">
            <v-text-field
              class="swap-input-wrapper"
              label="First name"
              placeholder="first name"
              v-model="KYC.info.first_name" 
            >
            </v-text-field>            
          </div>

          <div class="sheet-row">
            <v-autocomplete
              label="Gender"
              v-model="KYC.info.gender"
              :items ="this.vwObj.gender"              
            ></v-autocomplete>
          </div>

          <div class="sheet-row">
            <v-text-field
              class="swap-input-wrapper"
              label="E-Mail"
              placeholder="E-Mail"
              v-model="KYC.info.email" 
              @change="methodKYC()"
            >
            </v-text-field>            
          </div>


          <div class="sheet-row">
            <v-text-field
              class="swap-input-wrapper"
              label="Mobile"
              placeholder="Mobile"
              v-model="KYC.info.mobile" 
            >
            </v-text-field>            
          </div>
 

          <div class="sheet-row">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
            >

                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        label="Date of birthday"                        
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      ref="picker"
                      v-model="date"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="save"
                    ></v-date-picker>
                    
            </v-menu>
              
            
            <!-- <v-date-picker
              v-model="KYC.info.dob"              
              class="mt-3"
              min="1950-06-15"              
            ></v-date-picker> -->
             <!-- max="2018-03-20" -->
                        
            <!-- <v-text-field
              class="swap-input-wrapper"
              label="Date Of Birth"
              placeholder="dob"
              v-model="KYC.info.dob" 
            >
            </v-text-field>             -->
          </div>

          <div class="sheet-row">            
            <v-autocomplete
              label="Nationality"
              v-model="KYC.info.nationality"
              :items ="this.vwObj.nationality"              
            ></v-autocomplete>
          </div>

          <div class="sheet-row">
            
            <template>
              <v-file-input
                label="proofResidence-거주지증명"
                variant="filled"
                show-size 
                prepend-icon="mdi-camera"
                v-model="KYC.info.proofResidence" 
              ></v-file-input>
            </template>

          </div>
          <!-- Infomation End  -->

          <div class="sheet-title1">* Passport</div>          

          <div class="sheet-row">
            <v-text-field
              class="swap-input-wrapper"
              label="Passport Number"
              placeholder="Passport Number"
              v-model="KYC.info.idNumber" 
            >
            </v-text-field>            
          </div>

          <div class="sheet-row">            
            <!-- 
              accept="image/jpg, image/jpeg, application/pdf" 
              :rules="rules" 
           -->
            <template>              
              <v-file-input                                
                label="Face Photo"
                variant="filled"
                show-size 
                prepend-icon="mdi-camera"
                v-model="KYC.info.facePhoto" 
              ></v-file-input>
            </template>
          </div>

          <div class="sheet-row">            
            <template>
              <v-file-input
                label="Passport Front Photo"
                variant="filled"
                show-size 
                prepend-icon="mdi-camera"
                v-model="KYC.info.idFrontPhoto" 
              ></v-file-input>
            </template>
          </div>
          
          <div class="sheet-row">            
            <template>
              <v-file-input
                label="Passport Back Photo"
                variant="filled"
                show-size 
                prepend-icon="mdi-camera"
                v-model="KYC.info.idBackPhoto" 
              ></v-file-input>
            </template>
          </div>


          <!--  


             "facePhoto": "string", - (얼굴인식 사진 - base64인코딩, 사진은 1M미만, 필수) 
            "idBackPhoto": "string", - (여권뒷면 사진 - base64인코딩, 사진은 1M미만, 필수)
            "idFrontPhoto": "string", - (여권앞면 사진 - base64인코딩, 사진은 1M미만, 필수)            
            "idNumber": "string", - (여권번호, 필수)
            
          -->
 
          <v-divider class="my-5"></v-divider>

        </v-card-text>

        <!-- kyc  --> 

        <v-btn
          color="primary"
          fixed
          style="bottom:0;"
          tile
          block
          large
          height="56px"
          @click="submitKYC" 
        >
          Authenticate
        </v-btn>
      </v-card>

    </v-bottom-sheet>
    

    <v-dialog v-model="messageModal" max-width="30rem">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text v-html="message"> </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="messageModal = false">
            {{ $t('swap.messageModal.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    </div>

  </v-container>
</template>

<script>
import BigNumber from 'bignumber.js'
import PhoneOverlay from '../../components/PhoneOverlay.vue'

export default {
  components: { PhoneOverlay },
  
  data: () => ({
    tab1: 0,
    date: null,
    menu: false ,     
    fee: null,
    valid: true,
    fromType: null,
    toAddress: '',
    configId: null,
    toType: null,
    fromAmount: null,
    toAmount: 0,
    amountRules: [(v) => !!v || '', (v) => v > 0 || ''],
    coinRules: [(v) => !!v || ''],
    messageModal: false,
    message: null,
    confirmDialog: false,
    fee: null,
    noConfig: false,
    hash: null , 
    KYC:{ proc : false , info:{}}  , 
    selectAry:['Afghanistan','Canada','Zimbabwe'] , 
    vwObj :  {
      nationality : ['Afghanistan','Canada','Zimbabwe','Zambia','Yugoslavia','Yemen','Yemen','Wallis and fortuna','Vietnam','Venezuela','Vatican City','Vanuatu','Uzbekistan','Uruguay','United States Virgin Islands','United States','United Kingdom','United Arab Emirates','Ukraine','Uganda','Tuvalu','Turks and caicos islands','Turkmenistan','Turkey','Tunisia','Trinidad and Tobago','Tonga','Tokelau islands','Togo','The Republic of Congo','the Falkland Islands','The east German','The Dominican Republic','Thailand','Tanzania','Tajikistan','Taiwan','Syria','Switzerland','Sweden','Swaziland','Suriname','Sudan','Sri Lanka','Spain','South Sudan','South Africa','Somalia','Solomon Islands','Slovenia','Slovakia','Sint Maarten','Singapore','Sierra Leone','Seychelles','Serbia','Senegal','Saudi Arabia','Sao Tome and Principe','San Marino','Samoa','Saint Vincent and the Grenadines','Saint Pierre and Miquelon','Saint Lucia','Saint Kitts-Nevis','Saint Helena','Rwanda','Russia','Romania','Reunion','Qatar','Puerto Rico','Portugal','Poland','Philippines','Peru','Paraguay','Papua New Guinea','Panama','Palestine','Palau','Pakistan','Oman','Norway','Northern Mariana Islands','Niue','Niger','Nicaragua','New Zealand','New Caledonia','Netherlands','Nepal','Nauru','Namibia','Myanmar','Mozambique','Morocco','Montserrat','Montenegro','Mongolia','Monaco','Moldova','Micronesia','Mexico','Mauritius','Mauritania','Martinique','Marshall Islands','Malta','Mali','Maldives','Malaysia','Malawi','Madagascar','Macedonia','Macao','Luxembourg','Lithuania','Liechtenstein','Libya','Liberia','Lesotho','Lebanon','Latvia','Laos','Kyrgyzstan','Kuwait','Korea','Kiribati','Kazakhstan','Jordan','Japan','Jamaica','Italy','Israel','Ireland','Iraq','Iran','Indonesia','India','Iceland','Hungary','Hong kong','Honduras','Haiti','Guyana','Guinea-Bissau','Guinea','Guatemala','Guam','Guadeloupe','Grenada','Greenland','Greece','Gilbert islands','Gibraltar','Ghana','Germany','Georgia','Gambia','Gabon','French Polynesia','French Guiana','France','Finland','Fiji','Faroe Islands','Ethiopia','Estonia','Eritrea','Equatorial Guinea','Ellis islands','El Salvador','Egypt','Ecuador','East Timor','Dominica','Djibouti','Diego Garcia','Denmark','Democratic Republic of the Congo','slovakia','Czecho','Cyprus','Curacao','Cuba','Croatia','Cote D`Ivoire','Costa Rica','Cook Islands','Mayotte ','Comoros ','Colombia','China','Chile','Chad','Central African Republic','Cayman Islands','Caribbean Netherlands','Cape Verde','Cameroon','Cambodia','Burundi','Burkina Faso','Bulgaria','Brunei','British Virgin Islands','Brazil','Botswana','Bosnia and Herzegovina','Bolivia','Bhutan','Bermuda','Benin','Belize','Belgium','Belarus','Barbados','Bangladesh','Bahrain','Bahamas','Azerbaijan','Austria','Australia','Ascension Island','Aruba','Armenia','Argentina','Antigua and Barbuda','Anguilla','Angola','Andorra','American Samoa','Algeria','Albania']
      , gender :   ['Male'  , "Female" ] 
    } , 
    rules: [
      files => !files || !files.some(file => file.size > 1_097_152) || 'Avatar size should be less than 1MB!'
    ],

  }),
  computed: {

    auth_sms() {
      return true ; 
      return this.$store.getters.user.auth_sms === 'Y' ? true : false
    },
    myWalletAdress() {
      
      return this.$store.getters.user.wallet_address
    },
    fromWallet() {
      console.log("dev: " ,  this.$store.getters.wallet ) ; 
      return this.$store.getters.wallet.filter((item) => item.name === 'ETH' ||item.name === 'USDT' ||item.name === 'CCC1'   )

      return this.$store.getters.wallet
    },
    ethBalance() {
      return this.$store.getters.wallet.filter((i) => i.name === 'ETH')[0]
        .balance
    },
    toWallet() {
      // console.log("To : " , this.$store.getters.wallet.filter((item) => item.name === 'CCC' ||item.name === 'LSS'  )  )  ;
      return this.$store.getters.wallet.filter((item) => item.name === 'CCC' ||item.name === 'LSS'  )

      // if (this.fromType === 'plp')
      //   return this.$store.getters.wallet.filter((item) => item.name === 'PLI')
      // if (this.fromType === 'pli')
      //   return this.$store.getters.wallet.filter((item) => item.name === 'PLP')
      // return this.$store.getters.wallet.filter(
      //   (item) => item.name === 'PLP' || item.name === 'PLI'
      // )
    },
    upperFrom() {
      return this.fromType ? this.fromType.toUpperCase() : null
    },
    upperTo() {
      return this.toType ? this.toType.toUpperCase() : null
    },
    prices() {
      return this.$store.getters.prices
    },
    loading() {
      return this.$store.getters.loading
    },
    disabled() {
      return !this.fromType || !this.toType || this.noConfig
    },
    fromBalance() {
      return this.fromType
        ? this.fromWallet.filter((item) => item.value === this.fromType)[0]
            .balance
        : 0
    },    
    availableToken() {
      if (!this.fromType || !this.fromAmount || this.fromAmount <= 0)
        return false

      return (
        BigNumber(this.fromAmount).toNumber() <=
        BigNumber(this.fromBalance).toNumber()
      )
    },
    perToken() {
///      console.log(  BigNumber('1').times(this.prices[`price_${this.toType}`]).toFixed(8)   , this.prices[`price_${this.toType}`] ) ;
///      console.log(  BigNumber('1').times(this.prices[`price_${this.toType}`]) .div(this.prices[`price_${this.fromType}`]).toFixed(8)   , this.prices[`price_${this.fromType}`] ) ;

      return this.comma(
        BigNumber('1')
          .times(this.prices[`price_${this.toType}`])
          .div(this.prices[`price_${this.fromType}`])
          .toFixed(8)
      )
    },
    expectFee() {
      return this.fromType === 'pli'
        ? this.fromAmount
          ? BigNumber(this.fromAmount)
              .div(BigNumber('1000'))
              .toFixed(2, 1)
          : 0
        : (this.fee * 60000) / 10000000000
    },
    isAvailableFee() {
      if (this.fromType === 'eth' || this.fromType === 'pli')
        return BigNumber(this.fromBalance).isGreaterThanOrEqualTo(
          BigNumber(this.fromAmount).plus(BigNumber(this.expectFee))
        )
      return this.expectFee <= this.ethBalance
    }
  },
  created() {

    // console.log("user: " , this.$store.getters.user ) ;
    
    this.KYC.proc = this.$store.getters.user.kyc ; 


    this.$store.commit('loading', true)
    this.$store.dispatch('FETCH_PRICES')
    // this.$store.dispatch('FETCH_WALLET')    
    console.log( "prices :: "  ,this.$store.prices   )

    this.amountRules = [
      (v) => !!v || '스왑하실 수량을 확인해주세요.',
      (v) => v > 0 || '스왑하실 수량을 확인해주세요.'
    ]
    this.coinRules = [(v) => !!v || this.$t('swap.errCoin')]
    this.$store
      .dispatch('GETGAS')
      .then((res) => {
        if (res.data && res.data.fast) {
          this.fee = res.data.fast
          return this.$store.dispatch('api_config', {
            column: ['id', 'admin_address']
          })
        } else throw res
      })
      .then((response) => {
        this.$store.commit('loading', false)
        if (response.status === 200) {
          this.toAddress = response.data.admin_address
          this.configId = response.data.id
        } else throw response
      })
      .catch((err) => {
        this.noConfig = true
        this.$store.dispatch('toast', {
          toast: true,
          toast_msg: this.$t('errorServer'),
          timeout: 3000
        })
      })
  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    } ,      
    checkKYC(){
        console.log( " checkKYC :: " ,  this.objCheck(this.KYC.info.email) , this.objCheck(this.KYC.info.emailsss ) ) ; 


// email
// facePhoto
// first_name
// gender
// idBackPhoto
// idFrontPhoto
// idNumber
// last_name
// mobile
// nationality
// proofResidence


      
      return true ; 
      // if() 
    } , 

  },
  methods: {
    tab1Act( num ){

      if( this.KYC.proc ==  false && num > 0 ) {
        this.confirmDialog = true ;
        this.tab1 = 0   ; 
      }else{
        this.tab1 = num  ; 
      }
      

    },
    methodKYC(){
      console.log(this.value) ; 
    } , 
    objCheck( ob ){
      return (ob && ob != '') ? true : false ; 
    } , 
    save (date) {
      this.$refs.menu.save(date)
    } , 
    imgSrc(item) {
      console.error( item ) ; 
      let src
      try {
        src = require(`@/assets/svg/${item + '-logo.svg'}`)
      } catch (e) {
        try {
          src = require(`@/assets/svg/${item + '-logo.png'}`)
        } catch (e) {
          src = require(`@/assets/svg/ETH-logo.svg`)
        }
      }
      return src
    },     
    // calc(i) {
    //   console.log( "methods :: calc : " , i ,  this.toType  , this.prices[`price_${this.fromType}`] , this.fromType  , this.prices  )
    //   if (this.toType && this.fromAmount && this.fromType) {
    //     // console.log(this.prices, this.fromAmount, this.fromType, i)
    //     if (this.toType === 'pli') {
    //       this.toAmount = BigNumber(i)
    //         .times(this.prices[`price_${this.fromType}`])
    //         .div(this.prices[`price_${this.toType}`])
    //         .toFixed(2)
    //     } else {
    //       this.toAmount = BigNumber(i)
    //         .times(this.prices[`price_${this.fromType}`])
    //         .div(this.prices[`price_${this.toType}`])
    //         .toFixed(8)
    //     }
    //   } else {
    //     this.toAmount = 0
    //   }
      
    //   return this.toAmount
    // },
 
    onKeydown(e) {
      if (
        e.keyCode === 101 ||
        e.keyCode === 69 ||
        e.keyCode === 45 ||
        e.keyCode === 43
      )
        e.preventDefault()

      let regx = /^\d*[.]\d{8}$/
      if (this.fromType === 'usdt') regx = /^\d*[.]\d{6}$/
      if (this.fromType === 'pli' || this.fromType === 'plp')
        regx = /^\d*[.]\d{2}$/
      const _value = e.target.value

      if (regx.test(_value)) e.preventDefault()
    },
    // onClickMask(type) {
    //   if (this.fromType) {
    //     const len = this.fromAmount.length
    //     if (this.$refs[type].setSelectionRange !== undefined) {
    //       el.setSelectionRange(len, len)
    //     }
    //   }
    //   this.$refs[type].focus()
    // },
    onClickMax() {
      if (this.fromType === 'pli') {
        const pli = this.fromBalance
        const tmp = BigNumber(pli)
          .times(BigNumber(1000 / 1001))
          .toFixed(2, 0)
        const fee = BigNumber(tmp)
          .div(BigNumber('1000'))
          .toFixed(2, 1)
        if (tmp + fee > pli) {
          this.fromAmount = BigNumber(pli)
            .times(BigNumber(1000 / 1001))
            .toFixed(2, 1)
        } else {
          this.fromAmount = tmp
        }
      } else if (this.fromType === 'eth') {
        this.fromAmount = BigNumber(this.fromBalance - this.expectFee).toFixed(
          8,
          1
        )
      } else {
        this.fromAmount = this.fromBalance
      }
    },
    submitKYC(){

    // console.log( "Submit :: " ,  this.objCheck( this.KYC.info.email )     )      
    console.log( "Submit !!!!! " )   ; 

    if( 
      this.objCheck( this.KYC.info.email ) && 
      this.objCheck( this.KYC.info.facePhoto ) && 
      this.objCheck( this.KYC.info.first_name ) && 
      this.objCheck( this.KYC.info.gender ) && 
      this.objCheck( this.KYC.info.idBackPhoto ) && 
      this.objCheck( this.KYC.info.idFrontPhoto ) && 
      this.objCheck( this.KYC.info.idNumber ) && 
      this.objCheck( this.KYC.info.last_name ) && 
      this.objCheck( this.KYC.info.mobile ) &&        
      this.objCheck( this.KYC.info.nationality ) && 
      this.objCheck( this.KYC.info.last_name ) && 
      this.objCheck( this.KYC.info.proofResidence ) 
    
    ){

      // console.log( " true ::" ,  this.KYC.info)   ; 
      if(  this.KYC.info.proofResidence.size  > 1000000  || this.KYC.info.proofResidence.size  > 1000000 || this.KYC.info.idBackPhoto.size  > 1000000 || this.KYC.info.idFrontPhoto.size  > 1000000     )  {
        alert('첨부 이미지는 1MB를 초과할수 없습니다.') ;         
        return ;
      } ;  

    }else { 
      
      // console.log( " false ::" ,  this.KYC.info.proofResidence)  
      // console.log( " false ::" ,  this.KYC.info.proofResidence.size)  
      // console.log( " false ::" ,  this.KYC.info)   

    }
 


      console.log( this.KYC)  ; 
      
    } , 
    submitSwap() {
      this.$store.commit('loading', true) ; 
      this.confirmDialog = false ;
      switch (this.fromType) {
        case 'pli':
          // this.$store
          //   .dispatch('balance_pli')
          //   .then((res) => {
          //     if (res.data && res.data.status) {
          //       if (
          //         BigNumber(res.data.balance).isGreaterThanOrEqualTo(
          //           BigNumber(this.fromAmount).plus(BigNumber(this.expectFee))
          //         )
          //       ) {
          //         const params = {
          //           senderAddress: this.myWalletAdress,
          //           valueAmount: this.fromAmount
          //         }
          //         return this.$store.dispatch('exchange_pli', params)
          //       } else throw 'insufficient'
          //     } else throw res
          //   })
          const _params = {
            senderAddress: this.myWalletAdress,
            valueAmount: this.fromAmount
          }
          if (
            BigNumber(this.fromAmount).toNumber() <=
            BigNumber(this.fromBalance).toNumber()
          ) {
            this.$store
              .dispatch('exchange_pli', _params)
              .then((res) => {
                if (res.data && res.data.status) {
                  this.$store.commit('loading', false)
                  this.$router.replace({
                    name: 'swap-success',
                    params: { hash: res.data.txHash }
                  })
                  this.$refs.form.reset()
                } else if (res.data && res.data.error) throw res.data.error
                else throw res
              })
              .catch((err) => {
                this.$store.commit('loading', false)
                if (err === 'insufficient') {
                  this.messageModal = true
                  this.message = this.$t('point.insufficientError')
                } else if (err === 'xuser') {
                  this.messageModal = true
                  this.message = this.$t('point.xuserError')
                } else {
                  this.$store.dispatch('toast', {
                    toast: true,
                    toast_msg: this.$t('errorServer'),
                    timeout: 3000
                  })
                }
                this.$refs.form.reset()
              })
          } else {
            this.messageModal = true
            this.message = this.$t('point.insufficientError')
          }

          break
        case 'plp':
          this.$store
            .dispatch('AVAIL_TOKEN', {
              token: 'plp'
            })
            .then((res) => {
              const data = res.data

              const sum = BigNumber(data.locked.sum)
                .plus(BigNumber(data.staking.sum))
                .plus(BigNumber(data.pending.SUM))
                .plus(BigNumber(this.fromAmount))
                .toNumber()
              // if (sum > this.fromBalance) throw { error: 'insufficient' }

              const params = {
                amount: this.fromAmount,
                fee: this.fee,
                toAddress: this.toAddress,
                sendType: this.fromType
              }
              return this.$store.dispatch('send_transaction', params)
            })
            .then((res) => {
              // console.log('res.data', res.data);
              if (res.data && res.data.status) {
                // 성공시 처리
                this.hash = res.data.hash
                const params = {
                  configId: this.configId,
                  fromAmount: this.fromAmount,
                  fromType: this.fromType,
                  hash: res.data.hash,
                  priceId: this.prices.id,
                  toAmount: this.toAmount,
                  toType: this.toType
                }
                // console.log('uswap: ', params);
                return this.$store.dispatch('user_swap', params)
              } else throw res
            })
            .then((res) => {
              // console.log('uswap: ', res);
              if (res.data && res.data.status) {
                this.$store.commit('loading', false)
                this.$router.replace({
                  name: 'swap-success',
                  params: { hash: res.data.hash }
                })
                this.$refs.form.reset()
              } else throw 'db'
            })
            .catch((err) => {
              // console.log(err)
              this.$store.commit('loading', false)
              if (err.error && err.error.indexOf('insufficient') !== -1) {
                this.message = this.$t('swap.messageModal.amountFail')
                this.messageModal = true
              } else if (err.error) {
                this.message = `${this.$t('swap.messageModal.fail')}<br/>(${
                  err.error
                })`
                this.messageModal = true
              } else {
                this.$store.dispatch('toast', {
                  toast: true,
                  toast_msg: this.$t('errorServer'),
                  timeout: 3000
                })
              }
              this.$refs.form.reset()
            })
          break
        case 'eth':
        case 'usdt':
          let sum = 0
          if (this.fromType === 'eth') {
            sum = BigNumber(this.fee)
              .times(60000)
              .div(10000000000)
              .plus(this.fromAmount)
              .toNumber()
          } else {
            sum = BigNumber(this.fromAmount)
          }

          if (sum > this.fromBalance) throw { error: 'insufficient' }

          const params = {
            amount: this.fromAmount,
            fee: this.fee,
            toAddress: this.toAddress,
            sendType: this.fromType
          }
          this.$store
            .dispatch('send_transaction', params)
            .then((res) => {
              console.log('res.data', res.data);
              if (res.data && res.data.status) {
                // 성공시 처리
                this.hash = res.data.hash
                const params = {
                  configId: this.configId,
                  fromAmount: this.fromAmount,
                  fromType: this.fromType,
                  hash: res.data.hash,
                  priceId: this.prices.id,
                  toAmount: this.toAmount,
                  toType: this.toType
                }
                // console.log('uswap: ', params);
                return this.$store.dispatch('user_swap', params)
              } else throw res
            })
            .then((res) => {
              console.log('uswap: ', res);
              if (res.data && res.data.status) {
                this.$store.commit('loading', false)
                this.$router.replace({
                  name: 'swap-success',
                  params: { hash: res.data.hash }
                })
                this.$refs.form.reset()
              } else throw 'db'
            })
            .catch((err) => {
               console.log(err)
              this.$store.commit('loading', false)
              if (err.error && err.error.indexOf('insufficient') !== -1) {
                this.message = this.$t('swap.messageModal.amountFail')
                this.messageModal = true
              } else if (err.error) {
                this.message = `${this.$t('swap.messageModal.fail')}<br/>(${
                  err.error
                })`
                this.messageModal = true
              } else if (err === 'db') {
                this.message = `스왑신청이 실패하였습니다. 관리자에게 문의해주세요.`
                this.messageModal = true
              } else {
                this.$store.dispatch('toast', {
                  toast: true,
                  toast_msg: this.$t('errorServer'),
                  timeout: 3000
                })
              }
              this.$refs.form.reset()
            })
          break
      }
    },
    reset() {
      this.$refs.form.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.select-item .col {
  padding: 0 0.5rem;
}
.select-item {
  width: 100%;
  color: #121212;
}
.swap-icon {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
}
.bottom-btn-left {
  position: fixed;
  width: 50%;
  left: 0;
  bottom: 55px;
}
.bottom-btn-right {
  position: fixed;
  width: 50%;
  left: 50%;
  bottom: 55px;
}
.label-wrapper {
  font-weight: bold;
  font-size: 0.85rem;
  margin-left: 1rem;
}
.max-btn {
  display: flex;
  justify-content: flex-end;
  height: 0;
  transform: translateY(-15px);
}
// .mask-wrapper {
//   background-color: #fff;
//   margin: 0 13px 0 12px;
//   text-align: right;
//   transform: translateY(-56px);
// }
// .placeholder-wrapper {
//   text-align: left;
//   color: #797979;
// }
.bottom-btn-right.theme--light.v-btn.v-btn--disabled,
.bottom-btn-right.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #c8bae8 !important;
  color: #fff !important;
}
.sheet-title {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1.2rem;
}
.sheet-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.8rem auto;
}
 
.sheet-title1 {
  font-size: 0.8rem;
  font-weight: bold;
  text-align: left;
  margin-bottom: 1.2rem;
}


.logo-circle {
  background-color: #e2e2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-right: 0.2rem;
}
</style>
